/**
 * Translate description: Index page for users
 */

import { Link as ReactLink } from 'react-router-dom';
import { useLanguageContext } from "../../context/LanguageContext.js";
import AppProvider from '../../provider/AppProvider.js';

import Bread from '../../components/layout/BreadCrumbs.js';
import Title from '../../components/layout/Title.js';

import Typography from '@mui/joy/Typography';

import Button from '@mui/joy/Button';

import AddCircleOutlineRounded from '@mui/icons-material/AddCircleOutlineRounded';




import { ListProvider, useListContext } from '../../provider/ListProvider.js';
import { listEffect } from '../../utils/hooks/listEffect.js';
import { useInfo } from '../../utils/hooks/useInfo.js';
import { MessagesTable } from './MessagessTable.js';
// import Filters, { SearchFilter } from '../../components/MakeFilter.js';
import MessageFilter from './MessageFilter.js';
import { UserMessagesApi } from '../../utils/crud/user_message_api.js';

let user_messages_api = new UserMessagesApi();
function prepareRowToDisplay(row) {
  return row
}
const getLoader = (info, t) => {
  return async (listContext) => {
    let res = await user_messages_api.get(listContext)
    if (res.is_error) {
      if (!res.error) res.error = {}
      res.error.message = t("Load error") // ошибка которая будет отображена в таблице
      info(res.error.message, "danger") // ошибка во всплывашке
      return res
    }
    res.data = res.data.map(prepareRowToDisplay)
    return res;
  }
}
function _Index() {
  const { t } = useLanguageContext();
  const listContext = useListContext();
  const info = useInfo();
  listEffect(listContext, getLoader(info, t)) // говорим откуда брать данные для таблицы

  return (
    <>
      <Bread path={[{ name: t("User Messages") }]} />
      <Title>
        <Typography level="h2" component="h1" >
          {t("User messages")}
        </Typography>
      </Title>
      <MessageFilter />
      <MessagesTable />
    </ >
  );
}

export default function MessageIndex() {
  return (
    <AppProvider>
      <ListProvider default_sort={"created_at"} default_order={true}>
        <_Index />
      </ListProvider>
    </AppProvider>
  );
}